(function(){
  var root=document.querySelector('.hp-page');
  if(!root) return;

  /* reveal-on-scroll (respects reduced motion) */
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals=root.querySelectorAll('[data-reveal]');
  if(reduce||!('IntersectionObserver' in window)){
    reveals.forEach(function(el){ el.classList.add('in'); });
  }else{
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* mobile product-image carousel: dots in sync with swipe (re-queries dots so it survives metal-swap rebuilds) */
  function syncDots(media){
    var track=media.querySelector('.hp-track'); if(!track) return;
    var dots=media.querySelectorAll('.hp-dot'); if(dots.length<2) return;
    var i=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
    dots.forEach(function(d,di){ d.classList.toggle('active',di===i); });
  }
  function bindDots(media){
    media.querySelectorAll('.hp-dot').forEach(function(d,di){
      if(d._b) return; d._b=1;
      d.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); var t=media.querySelector('.hp-track'); if(t) t.scrollTo({left:di*t.clientWidth,behavior:'smooth'}); });
    });
  }
  root.querySelectorAll('.hp-media').forEach(function(media){
    var track=media.querySelector('.hp-track'); if(!track) return;
    var raf=null;
    track.addEventListener('scroll',function(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=null; syncDots(media); }); },{passive:true});
    bindDots(media);
  });

  /* metal swatch -> swap the card image carousel + price + product link in place (no navigation) */
  root.querySelectorAll('.hp-swatches .hp-sw').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      if(a.classList.contains('sel')) return;
      var card=a.closest('.hp-card'); if(!card) return;
      var media=card.querySelector('.hp-media');
      var track=media&&media.querySelector('.hp-track');
      var titleEl=card.querySelector('.hp-ctitle');
      var priceEl=card.querySelector('.hp-price .amt');
      var url=a.dataset.url||'#';
      var title=a.dataset.title||(titleEl?titleEl.textContent.trim():'');
      var imgs=(a.dataset.imgs||'').split('|').filter(Boolean);

      if(track&&imgs.length){
        track.innerHTML=imgs.map(function(u){
          return '<a class="hp-slide" href="'+url+'" aria-label="'+title+'"><img src="'+u+'" alt="'+title+'" width="600" height="600"></a>';
        }).join('');
        track.scrollLeft=0;
        var dots=media.querySelector('.hp-dots');
        if(imgs.length>1){
          if(!dots){ dots=document.createElement('div'); dots.className='hp-dots'; media.appendChild(dots); }
          dots.innerHTML=imgs.map(function(_,i){ return '<span class="hp-dot'+(i===0?' active':'')+'"></span>'; }).join('');
          bindDots(media);
        } else if(dots){ dots.remove(); }
      }
      if(priceEl&&a.dataset.price) priceEl.textContent=a.dataset.price;
      if(titleEl){ titleEl.setAttribute('href',url); if(a.dataset.title) titleEl.textContent=a.dataset.title; }
      var grp=a.parentNode;
      grp.querySelectorAll('.hp-sw').forEach(function(x){ x.classList.remove('sel'); });
      a.classList.add('sel');
    });
  });
})();
